import { useState } from 'react'
import {
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  useTranslate,
  required,
} from 'react-admin'
import { Grid, Box, FormHelperText } from '@material-ui/core'

import ScrutateursSelector from './components/ScrutateursSelector'
import PvToolbar from './components/PvToolbar'

const AgsFormTimeSheet = ({
  agId,
  setDefaultPresidentPVEmail,
  setDefaultSecretaryPVEmail,
  defaultPresidentPVEmail,
  defaultSecretaryPVEmail,
  imageIllustration3,
  optionRenderer,
  sendPv,
  loadingFile,
  getPvPreview,
}) => {
  const translate = useTranslate()

  // Only one field per type is require, if a field of one type if filled, the other one is disable
  const [presidentSelectValue, setPresidentSelectValue] = useState('')
  const [presidentInputValue, setPresidentInputValue] = useState('')

  const [secretarySelectValue, setSecretarySelectValue] = useState('')
  const [secretaryInputValue, setSecretaryInputValue] = useState('')

  const disabledMsg =
    "Champs désactivé. Vider l'autre champs du même type pour le réactiver."
  const marginBottomField = { marginBottom: '15px' }
  const minHeightFieldBloc = { minHeight: '146px' }

  const [presidentEmailIsValid, setPresidentEmailIsValid] = useState(true)
  const [secretaryEmailIsValid, setSecretaryEmailIsValid] = useState(true)

  const validateEmail = (email) => {
    if (!email) {
      return false
    }
    let re = /\S+@\S+\.\S+/
    return re.test(email)
  }

  return (
    <SimpleForm
      toolbar={
        <PvToolbar
          label={translate('hs.ags.generate_and_send_pv')}
          agId={agId}
          save={sendPv}
          presidentSelectValue={presidentSelectValue}
          presidentInputValue={presidentInputValue}
          presidentEmailIsValid={presidentEmailIsValid}
          secretarySelectValue={secretarySelectValue}
          secretaryInputValue={secretaryInputValue}
          secretaryEmailIsValid={secretaryEmailIsValid}
          validateEmail={validateEmail}
          loadingFile={loadingFile}
          getPvPreview={getPvPreview}
        />
      }
      defaultValues={{ agId: agId }}
      redirect={false}
      resource="signrequests"
      basePath="/"
      variant="outlined"
    >
      <Grid container>
        <Grid xs={12} md={6} item>
          <Grid style={minHeightFieldBloc}>
            <ReferenceInput
              label="Président"
              source="president_id"
              reference="ext_coproprietaires"
              inputProps={{
                onChange: (e, child) => {
                  setDefaultPresidentPVEmail(
                    child.props.children.props['data-email']
                  )
                },
              }}
            >
              <SelectInput
                disabled={presidentInputValue}
                helperText={presidentInputValue ? disabledMsg : ''}
                optionText={optionRenderer}
                style={marginBottomField}
                validate={[required()]} // Only to show the * icon, but not required to validate
                allowEmpty
                fullWidth
                onChange={(e) => setPresidentSelectValue(e.target.value)}
              />
            </ReferenceInput>
            <TextInput
              defaultValue={defaultPresidentPVEmail}
              style={{ display: 'inline-block', ...marginBottomField }}
              label="Président (email libre)"
              source="president_email"
              fullWidth
              validate={[required()]} // Only to show the * icon, but not required to validate
              disabled={presidentSelectValue}
              helperText={
                presidentSelectValue ? (
                  disabledMsg
                ) : !presidentEmailIsValid && presidentInputValue ? (
                  <FormHelperText style={{ color: 'red' }}>
                    Veuillez entrer une adresse email valide.
                  </FormHelperText>
                ) : (
                  ''
                )
              }
              onChange={(e) => {
                setPresidentInputValue(e.target.value)
                if (validateEmail(e.target.value))
                  setPresidentEmailIsValid(validateEmail(e.target.value))
              }}
              onBlur={(e) => {
                setPresidentEmailIsValid(validateEmail(e.target.value))
              }}
            />
          </Grid>

          <Grid style={minHeightFieldBloc}>
            <ReferenceInput
              label="Secrétaire"
              source="secretaire_id"
              reference="ext_coproprietaires"
              inputProps={{
                onChange: (e, child) => {
                  setDefaultSecretaryPVEmail(
                    child.props.children.props['data-email']
                  )
                },
              }}
            >
              <SelectInput
                disabled={secretaryInputValue}
                helperText={secretaryInputValue ? disabledMsg : ''}
                optionText={optionRenderer}
                style={marginBottomField}
                validate={[required()]} // Only to show the * icon, but not required to validate
                allowEmpty
                fullWidth
                onChange={(e) => setSecretarySelectValue(e.target.value)}
              />
            </ReferenceInput>
            <TextInput
              defaultValue={defaultSecretaryPVEmail}
              label="Secrétaire (email libre)"
              source="secretaire_email"
              fullWidth
              validate={[required()]} // Only to show the * icon, but not required to validate
              disabled={secretarySelectValue}
              style={marginBottomField}
              helperText={
                secretarySelectValue ? (
                  disabledMsg
                ) : !secretaryEmailIsValid && secretaryInputValue ? (
                  <FormHelperText style={{ color: 'red' }}>
                    Veuillez entrer une adresse email valide.
                  </FormHelperText>
                ) : (
                  ''
                )
              }
              onChange={(e) => {
                setSecretaryInputValue(e.target.value)
                if (validateEmail(e.target.value))
                  setSecretaryEmailIsValid(e.target.value)
              }}
              onBlur={(e) => {
                setSecretaryEmailIsValid(validateEmail(e.target.value))
              }}
            />
          </Grid>

          <ScrutateursSelector optionRenderer={optionRenderer} />
        </Grid>
        <Grid
          xs={12}
          md={6}
          item
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{ display: { xs: 'none', lg: 'block' } }}
            src={imageIllustration3}
            component={'img'}
            width={'400px'}
          />
        </Grid>
      </Grid>
    </SimpleForm>
  )
}

export default AgsFormTimeSheet
